module.exports = __webpack_public_path__ + "static/service-3217c0a234c0c5a0aea41b235c288360.webp";